<template>
    <modal @close="closeModal">
        <div class="u-margin-bottom">
            {{
                trans('confirm.delete-entity', {
                    entity: this.record.type + ' record: ' + this.record.name
                })
            }}
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray btn-ghost--dns | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record btn-ghost--dns" type="submit" @click="deleteRecord">
                {{ trans('action.delete') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { mapActions } from 'vuex';
import { apiMixin } from 'relapp-api';
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import DnsApi from '../services/api/dns.js';

export default {
    components: {
        Modal
    },
    mixins: [apiMixin],
    props: {
        domain: {
            type: String,
            required: true
        },
        record: Object
    },
    methods: {
        ...mapActions({
            setDnsStatus: 'dns/setStatus'
        }),
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Delete a record.
         */
        deleteRecord() {
            this.setDnsStatus(true);

            DnsApi.delete(this.record, this.routeParams, {
                data: { ...this.record }
            })
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.deleted')
                    });
                })
                .catch(error => {
                    if (error.response.data) {
                        EventBus.$emit('notification', {
                            type: 'error',
                            message: error.response.data.message
                        });
                    } else {
                        this.handleError(error);
                    }
                })
                .then(() => {
                    this.setDnsStatus(false);
                });

            this.$emit('close');
        }
    }
};
</script>
